/**
 * xmg-sec-mfa: the enrolment QR code, drawn from the server's module matrix (`qr_matrix`: rows of "0"/"1", dark =
 * "1", quiet zone excluded) as ONE SVG path. No image, data URI or HTML string crosses the API, so nothing here
 * depends on an `img-src` policy and nothing is injected as markup. A 4-module quiet zone is added around it, and
 * the code is always dark-on-white (an inverted QR code is unreadable to many authenticator apps), whatever the
 * theme.
 */
export function QrCode({ matrix, label }: { matrix: readonly string[]; label: string }): JSX.Element {
  const size = matrix.length;
  const quiet = 4;
  const total = size + quiet * 2;
  let path = "";
  matrix.forEach((row, y) => {
    for (let x = 0; x < row.length; x += 1) {
      if (row[x] === "1") path += `M${x + quiet} ${y + quiet}h1v1h-1z`;
    }
  });
  return (
    <svg
      className="mfaqr"
      role="img"
      aria-label={label}
      viewBox={`0 0 ${total} ${total}`}
      width={220}
      height={220}
      shapeRendering="crispEdges"
    >
      <rect className="mfaqr__light" width={total} height={total} />
      <path className="mfaqr__dark" d={path} />
    </svg>
  );
}
